import { useRouteMatch } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { DeferredText } from '@carsys/ui'
import { useFeature } from '@cbgms/base/feature-flags'
import { useCMSPromotionItem } from '../../hooks/use-cms-promotions'
import { pathCMSPromotionItem } from 'app/wholesaler/routing'
import { OrderPromotionItemUrl } from 'app/order/RouteConstants'

export const PromotionItemBreadCrumb = () => {
  const { t } = useTranslation()
  const openPromotionInOrder = useFeature('b2b-open-promotion-in-order')
  const paths = openPromotionInOrder ? [pathCMSPromotionItem(), OrderPromotionItemUrl] : pathCMSPromotionItem()
  const match = useRouteMatch<{ promotionItemID: string }>(paths)
  const promotionItemID = match?.params.promotionItemID ?? ''
  const queryData = useCMSPromotionItem(promotionItemID)

  return <DeferredText data={queryData}>{queryData?.data?.Title || t('cms-promotion.generic_title')}</DeferredText>
}

export default PromotionItemBreadCrumb
